// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"eecbc16a","271":"e45e2fa0","309":"544f8e5c","404":"77207020","413":"8ff678b7","453":"4f0fe248","488":"497386fb","628":"53b447e5","652":"479a2af7","695":"9167c8e0","763":"81bba24e","858":"94f442fb"}[chunkId] + ".chunk.js";
};